import React from 'react';
import { IReportSchema } from '@/api/release';
import { StatusColor, StatusLabels } from '@/utils/constants/testRun';
import _ from 'lodash';

type PieChartLabelProps = {
  rawLabels: string[];
  report?: IReportSchema;
};

export const PieChartLabel: React.FC<PieChartLabelProps> = ({
  rawLabels,
  report,
}) => {
  return (
    <>
      {rawLabels.map(e => {
        const total = _.get(report?.status, `${e}.total`, 0);
        const percentage = _.get(report?.status, `${e}.percentage`, 0) * 100;

        const label = `${total} ${StatusLabels[e]} ${percentage.toFixed(1)}%`;

        return (
          <div className="flex flex-row items-center gap-2 my-1" key={e}>
            <div
              className="w-3 h-3"
              style={{ backgroundColor: StatusColor[e] }}
            />
            <span className="text-sm">{label}</span>
          </div>
        );
      })}
    </>
  );
};
